import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import WalletView from "../../../../user/WalletView.tsx";

export const Route = createFileRoute('/_app/profiles/$player_uid/wallet')({
    component: RouteComponent,
})

function RouteComponent() {
    return <WalletView />
}
